import { render, staticRenderFns } from "./member_fans.vue?vue&type=template&id=2ff85c1e&scoped=true&"
import script from "./member_fans.vue?vue&type=script&lang=js&"
export * from "./member_fans.vue?vue&type=script&lang=js&"
import style0 from "./member_fans.vue?vue&type=style&index=0&id=2ff85c1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff85c1e",
  null
  
)

export default component.exports